export function getHost() {
    if (window.isKuaikanMini) {
        // 如果当前是小程序环境 使用小程序host
        return process.env.VUE_APP_MINI_HOST;
    }

    if (location.origin.includes(process.env.VUE_APP_MINI_HOST)) {
        // 如果当前页面地址包含小程序host 使用小程序host
        return process.env.VUE_APP_MINI_HOST;
    }

    return process.env.VUE_APP_TOPIC_HOST; // 其他情况使用卡片host
}
